// extracted by mini-css-extract-plugin
module.exports = {"embeddedWrapper":"embeddedWrapper___1iShe","playerWrapper":"playerWrapper___3H4bW"};